import React from "react";

function Footer() {
    return (
        <div>
            {/* footer */}
  <section className="bottom-footer pt-2 pb-lg-4 pb-md-3 pb-sm-3 pb-3">
    <div className="container pb-lg-5 pb-md-5 pb-sm-4 pb-3">
      <div className="footer-lays-head text-center mb-lg-5 mb-md-4 mb-3">
        <div className="mb-3">
          <a href="/contact" className="register-btn register-btn--light">Book Now</a>
        </div>
        <h5>
          <a href="/">Adya Yoga</a>
        </h5>
      </div>
      <div className=" footer-top text-center">
        <p>
          <span>Address</span>: Adya Yoga Shala <br/>
          Edificio Torremar II, Numero 2, Avenida Juan Carlos I, 65, Portal 6, <br/> 35660 Corralejo, Las Palmas, Spain.</p>
        <p className="pt-2">
          <span> Phone</span> :+34 646386896</p>
          <p className="pt-2">
          <span> WhatsApp</span> :+91 98391 88783</p>
        <p className="pt-2">
          <span>Email</span> :
          <a href="mailto:yogaadya108@gmail.com">yogaadya108@gmail.com</a>
        </p>
      </div>
      <div className="bottom-icons mt-md-4 mt-3 text-center">
        <ul>
          <li>
            <a href="https://www.facebook.com/jigyasaalways">
              <span className="fa fa-facebook"></span>
            </a>
          </li>          
          <li>
            <a href="https://www.youtube.com/@YogaAdya108">
              <span className="fa fa-youtube"></span>
            </a>
          </li>
          <li>
            <a href="https://mail.google.com/mail/?view=cm&fs=1&to=yogaadya108@gmail.com" target="_blank">
              <span className="fa fa-envelope"></span>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/yogaadya108">
              <span className="fa fa-instagram"></span>
            </a>
          </li>
        </ul>
      </div>

      {/* move icon */}
      <div className="text-center mt-lg-5 mt-md-4 mt-3">
        <a href="#home" className="move-top text-center mt-3">
          <span className="fa fa-arrow-up" aria-hidden="true"></span>
        </a>
      </div>
      {/*//move icon */}
    </div>
  </section>
  {/*//footer */}
  {/* footer-copy */}
  <footer>
    <div className="bottem-tree-footer text-center py-md-4 py-3">
      <p>
        © 2025 Adya Yoga. All Rights Reserved | Developed by 
        <a href="https://www.linkedin.com/in/shashi-kant-kushwaha-72503067/" target="_blank" rel="noreferrer"> Shashi Kant</a>
      </p>
    </div>
    {/* //footer-copy */}
  </footer>
        </div>
    )
}
export default Footer;
